import Column from '@components/column'
import React, { Fragment } from 'react'
import MaintainanceMode from './maintainance-mode'
import CommssionSetting from './commision-setting'
import RescheduleSetting from './reschedule-setting'
import CancellationSetting from './cancellation-setting'
import Wrapper from '@components/wrapper'

const PlatformSettings = () => {
  return (
    <Fragment>
      <Column>
        <MaintainanceMode />
        <Wrapper>
          <CommssionSetting />
          <br />
          <RescheduleSetting />
        </Wrapper>
        <CancellationSetting />
      </Column>
    </Fragment>
  )
}

export default PlatformSettings
